import { render, staticRenderFns } from "./repayment-history.vue?vue&type=template&id=8ebe0ce0&scoped=true&"
import script from "./repayment-history.vue?vue&type=script&lang=js&"
export * from "./repayment-history.vue?vue&type=script&lang=js&"
import style0 from "./repayment-history.vue?vue&type=style&index=0&id=8ebe0ce0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebe0ce0",
  null
  
)

export default component.exports